
export enum LabControllerInputType {
    Text = "Text",
    Button = "Button",
    Graph = "Graph",
    Analog = "Analog",
    Slider = "Slider",
    Toggle = "Toggle",
    Gauge = "Gauge",
    Warning = "Warning",
    Message = "Message"
}